import darkImg from '../static/dark.png';
import lightImg from '../static/light.png';
import spanishImg from '../static/spain.png';
import usaImg from '../static/usa.png';

const THEME_OPTIONS = [
  {
    name: 'lightTheme',
    src: lightImg,
    value: 'light',
  },
  {
    name: 'darkTheme',
    src: darkImg,
    value: 'dark',
  },
];

const LANGUAGE_OPTIONS = [
  {
    name: 'English',
    src: usaImg,
    key: 'english',
    value: 'en',
  },
  {
    name: 'Spanish',
    src: spanishImg,
    key: 'spanish',
    value: 'es',
  },
];

const PERMISSIONS_KEY_TO_LABEL: { [key: string]: string } = {
  adminPermissions: 'Admin',
  employeePermissions: 'Employee',
  managerPermissions: 'Manager',
};

const PERMISSION_ACTIONS_TO_LABEL: { [key: string]: any } = {
  sheets: {
    visibility: {
      view: {
        text: 'teamViewSalaryData',
        tooltip: 'teamViewSalaryDataTooltip',
      },
      salaryData: {
        text: 'teamViewSalaryData',
        tooltip: 'sheetsViewSalaryDataTooltip',
      },
      timecards: {
        text: 'sheetsViewTimecards',
        tooltip: 'sheetsViewTimecardsTooltip',
      },
    },
    actions: {
      manage: {
        text: 'sheetsManageText',
        tooltip: 'sheetsManageTooltip',
      },
    },
  },
  team: {
    visibility: {
      salaryData: {
        text: 'teamViewSalaryData',
        tooltip: 'sheetsViewSalaryDataTooltip',
      },
      view: {
        text: 'teamViewSalaryData',
        tooltip: 'teamViewSalaryDataTooltip',
      },
    },
    actions: {
      manage: {
        text: 'teamManageText',
        tooltip: 'teamManageTooltip',
      },
    },
  },
  dashboard: {
    visibility: {
      view: {
        text: 'dashboardManageTooltip',
        tooltip: 'dashboardTooltip',
      },
    },
  },
  tasklists: {
    visibility: {
      view: {
        text: 'tasklistsViewText',
        tooltip: 'tasklistsViewTooltip',
      },
    },
    actions: {
      manage: {
        text: 'tasklistsManageText',
        tooltip: 'tasklistsManageTooltip',
      },
    },
  },
  schedules: {
    visibility: {
      salaryData: {
        text: 'teamViewSalaryData',
        tooltip: 'sheetsViewSalaryDataTooltip',
      },
    },
    actions: {
      availabilityPlanner: {
        text: 'manageSchedulesText',
        tooltip: 'manageSchedulesTooltip',
      },
      manage: {
        text: 'manageSchedulesText',
        tooltip: 'manageSchedulesTooltip',
      },
    },
  },
  orders: {
    actions: {
      manage: {
        text: 'ordersAssignData',
        tooltip: 'ordersAssignTooltip',
      },
    },
  },
  timeoff: {
    actions: {
      manage: {
        text: 'timeoffData',
        tooltip: 'timeoffTooltip',
      },
    },
  },
};

const INITIAL_DOR = {
  teamId: '',
  apiKey: '',
};

export {
  THEME_OPTIONS,
  LANGUAGE_OPTIONS,
  PERMISSIONS_KEY_TO_LABEL,
  PERMISSION_ACTIONS_TO_LABEL,
  INITIAL_DOR,
};
